import {
  AppBar as UiAppBar,
  AppBarProps,
  cn,
} from "@podcastsoundboard/ps-lib/ui"

/** Top bar that shifts right when the companion drawer is open. */
const AppBar = ({
  open,
  className,
  ...props
}: AppBarProps & { open?: boolean }) => (
  <UiAppBar
    {...props}
    className={cn(
      "z-[1201] transition-[width,margin] duration-200",
      open && "ml-[240px] w-[calc(100%-240px)]",
      className,
    )}
  />
)

export default AppBar
